import React from "react";
import {
  HeartIcon as HeartIconFill,
  CheckCircleIcon as CheckCircleIconFill,
  TrashIcon,
  PencilAltIcon,
} from "@heroicons/react/solid";
import { CheckCircleIcon, HeartIcon } from "@heroicons/react/outline";
import { useDispatch } from "react-redux";
import moment from "moment";

import type { IGoal } from "../types";
import IconButton from "../../../components/ui/IconButton";
import {
  deleteGoal,
  goalToggleComplete,
  goalToggleFavourite,
} from "../goalsSlice";
import useModal from "../../../hooks/useModal";
import { GoalsFormModal } from "./GoalsFormModal";
import { EDIT_GOAL } from "../../../utils/constants";

interface GoalItemProps {
  goal: IGoal;
}

export const GoalItem: React.FC<GoalItemProps> = ({ goal }) => {
  const dispatch = useDispatch();
  //
  const { isOpen, handleModaltoggle } = useModal();
  // function to handle toggle goal favourite
  const handleGoalToggleFavourite = () => dispatch(goalToggleFavourite(goal));
  // function to handle toggle goal complete
  const handleGoalToggleComplete = () => dispatch(goalToggleComplete(goal));
  // function to handle delete goal
  const handleGoalDelete = () => dispatch(deleteGoal(goal));

  return (
    <>
      {isOpen && (
        <GoalsFormModal
          onClose={handleModaltoggle}
          goal={goal}
          type={EDIT_GOAL}
        />
      )}
      <article className="secondary-bg flex flex-col gap-4 shadow-xl rounded-xl p-4 border primary-border-color">
        {/* goal header */}
        <header className="flex justify-between items-center">
          <div className="flex flex-col gap-1">
            <h1 className="font-medium text-xl truncate">{goal.title}</h1>
            <small className="sub-text font-thin text-xs">
              {moment(goal.createdAt).fromNow()}
            </small>
          </div>
          <div className="flex items-center gap-3">
            {/* edit button */}
            <PencilAltIcon
              role="button"
              className="secondary-icon"
              onClick={handleModaltoggle}
            />
            {/* delete button */}
            <TrashIcon
              role="button"
              className="secondary-icon"
              onClick={handleGoalDelete}
            />
          </div>
        </header>
        {/* goal description */}
        <p className="sub-text text-lg">{goal.description}</p>
        {/* goal footer */}
        <footer className="flex justify-between items-center">
          {/* favourite button & compelete button */}
          <div className="flex items-center gap-4">
            <IconButton
              Icon={goal.favourite ? HeartIconFill : HeartIcon}
              label="fav"
              className={`${
                goal.favourite ? "text-pink-700" : ""
              } hover:text-pink-700 on-hover hover:opacity-70`}
              iconClassName="secondary-icon"
              onClick={handleGoalToggleFavourite}
            />
            <IconButton
              Icon={goal.completed ? CheckCircleIconFill : CheckCircleIcon}
              label={goal.completed ? "completed" : "complete"}
              className={`${
                goal.completed ? "text-green-600" : ""
              } on-hover hover:text-green-600 hover:opacity-70`}
              iconClassName="secondary-icon"
              onClick={handleGoalToggleComplete}
            />
          </div>
        </footer>
      </article>
    </>
  );
};
